<section class="change-password-section">
    <header class="row page-header">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2 class=title>update password</h2>
                    <a [routerLink]="['/useraccount/user/profile']" class="back">BACK TO PROFILE</a>
                </div>
            </div>
        </div>
    </header>
    <main>
        <form [formGroup]="pageForm">
            <div class="form-section">
                <div class="container">
                    <div class="form-section-container">
                        <div class="row top-buffer-20 feedback-container">
                            <div class="col-md-6 offset-md-2">
                                <div class="alert alert-success" role="alert" *ngIf="successMessage != ''">
                                    <span class="glyphicon glyphicon-ok" aria-hidden="true"></span> {{ successMessage }}
                                </div>
                                <div class="alert alert-danger" role="alert" *ngIf="feedbackMessages.length > 0">
                                    <div *ngFor="let msg of feedbackMessages">
                                        <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                                        <span class="visually-hidden">Error:</span> {{ msg.details }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row top-buffer-20">
                            <div class="col-md-2">
                                <label>Current Password</label><span class="red">*</span>
                            </div>
                            <div class="col-md-4">
                                <input type="password" class="form-control" formControlName="currentPassword" placeholder="Current Password" maxlength="20"
                                    required #currentPassword />
                                 <sp-field-error [controlName]="'Current Password'" [control]="pageForm?.controls?.currentPassword"></sp-field-error>
                            </div>
                            <div class="col-md-6">
                                <a class="showMyTyping" (click)="showCurrentPassword($event)">{{ showTypingText }}</a>
                            </div>
                        </div>

                        <div class="row top-buffer-20">
                            <div class="col-md-2">
                                <label>New Password</label><span class="red">*</span>
                            </div>
                            <div class="col-md-4">
                                <input type="password" class="form-control" formControlName="newPassword" placeholder="New Password" maxlength="20"
                                    required />
                                <sp-field-error [controlName]="'New Password'" [control]="pageForm?.controls?.newPassword"></sp-field-error>
                            </div>
                            <div class="col-md-6">
                                <ol class="password-hint">
                                    <li>Passwords must have at least six characters that includes: lowercase letters, numbers, and symbols.</li>
                                </ol>
                            </div>
                        </div>

                        <div class="row top-buffer-20">
                            <div class="col-md-2">
                                <label>Confirm Password</label><span class="red">*</span>
                            </div>
                            <div class="col-md-4">
                                <input type="password" class="form-control" formControlName="confirmPassword" placeholder="Confirm Password" maxlength="20"
                                    required />
                                <sp-field-error [controlName]="'Confirm Password'" [control]="pageForm?.controls?.confirmPassword"></sp-field-error>
                            </div>
                        </div>
                        <div class="row top-buffer-20">
                            <div class="col-md-10 offset-md-2">
                                <button [disabled]="!pageForm?.valid || isSubmitting" type="submit" (click)="onChangePassword()" class="btn btn-success btn-change-password">save new password</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </main>
</section>
